import { useTranslation } from '../../../i18n';
import type { FacilityFlowCoreModulesOffersDtosOfferPositionDto as PositionDto } from '../../../api/generated/models';
import { BillingKinds } from '../../../utils/billingKind';

interface NoTaskHintProps {
  positions: readonly Pick<PositionDto, 'taskDefinitionId' | 'recurrenceKind'>[];
  className?: string;
}

/**
 * Warns about offer positions without a task: they have no schedule and are never planned — a
 * by-effort position is never billed at all, so that case is red (FAFD-27). Renders nothing when
 * every position has a task.
 */
export function NoTaskHint({ positions, className = '' }: NoTaskHintProps) {
  const { t } = useTranslation(['offers']);
  const withoutTask = positions.filter((p) => !p.taskDefinitionId);
  if (withoutTask.length === 0) return null;
  const effortWithoutTask = withoutTask.filter((p) => p.recurrenceKind === BillingKinds.ByEffort).length;

  return (
    <div
      className={`rounded-md border px-3 py-2 text-[12px] ${
        effortWithoutTask > 0
          ? 'border-red-200 bg-red-50 text-red-800'
          : 'border-amber-200 bg-amber-50 text-amber-900'
      } ${className}`}
    >
      {t('offers:positions.noTaskCount', { count: withoutTask.length })}
      {effortWithoutTask > 0 && (
        <> {t('offers:positions.noTaskEffortCount', { count: effortWithoutTask })}</>
      )}
    </div>
  );
}
